<template>
	<div>
		<div class="player_info_wrapper avg">
			<img class="player_key_img" src="@i/report/eval/avg.svg" alt="">
			<div class="player_info">
				<span class="player_value AkrobatM">{{avgInfo.avg}}</span>
				<p class="player_key">AVG</p>
			</div>
		</div>
		<ul class="Disp_AC Bet mt12">
			<li class="player_info_wrapper max">
				<img class="player_key_img" src="@i/report/eval/max.svg" alt="">
				<div class="player_info">
					<span class="player_value AkrobatM">{{avgInfo.max}}</span>
					<p class="player_key">MAX</p>
				</div>
			</li>
			<li class="player_info_wrapper min">
				<img class="player_key_img" src="@i/report/eval/min.svg" alt="">
				<div class="player_info">
					<span class="player_value AkrobatM">{{avgInfo.min}}</span>
					<p class="player_key">MIN</p>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'cl-eval-avg',
		props: {
			avgInfo: {
				type: Object,
				default: () => ({}),
			}
		}
	}
</script>

<style lang="scss" scoped>
	.player_info_wrapper {
        display: flex;
        padding: 12px;
        height: 76px;
        text-align: right;
        box-sizing: border-box;
        backdrop-filter: blur(30px);
        border-radius: 6px;
        &.avg {
            width: 212px;
            background: linear-gradient(110.54deg, rgba(99, 137, 243, 0.6) 13.63%, rgba(99, 137, 243, 0.6) 88.76%);
        }
        &.max, &.min {
            width: 100px;
            background: linear-gradient(110.54deg, rgba(99, 137, 243, 0.6) 13.63%, rgba(99, 137, 243, 0.6) 88.76%);
        }
        .player_key_img {
            width: 28px;
            height: 28px;
        }
        .player_info {
            flex: 1;
            .player_value {
                font-size: 26px;
                line-height: 32px;
                color: #fff;
            }
            .player_key {
                color: rgba(#fff, 0.6);
            }
        }
    }
</style>